import enCommon from './en/common/common.json';
import frCommon from './fr/common/common.json';

// Dynamic imports for components and containers
const enComponentsContext = require.context('./en/components', true, /\.json$/);
const enContainersContext = require.context('./en/containers', true, /\.json$/);
const frComponentsContext = require.context('./fr/components', true, /\.json$/);
const frContainersContext = require.context('./fr/containers', true, /\.json$/);

// Helper function to process all translations
const importAllTranslations = (context) => {
    const translations = {};
    context.keys().forEach((key) => {
        const moduleName = key.replace(/^\.\/|\.json$/g, '');
        translations[moduleName] = context(key);
    });
    return translations;
};

const enComponentTranslations = importAllTranslations(enComponentsContext);
const enContainerTranslations = importAllTranslations(enContainersContext);
const frComponentTranslations = importAllTranslations(frComponentsContext);
const frContainerTranslations = importAllTranslations(frContainersContext);

export const enMessages = {
    ...enCommon,
    ...Object.values(enComponentTranslations).reduce((acc, curr) => ({ ...acc, ...curr }), {}),
    ...Object.values(enContainerTranslations).reduce((acc, curr) => ({ ...acc, ...curr }), {})
};

export const frMessages = {
    ...frCommon,
    ...Object.values(frComponentTranslations).reduce((acc, curr) => ({ ...acc, ...curr }), {}),
    ...Object.values(frContainerTranslations).reduce((acc, curr) => ({ ...acc, ...curr }), {})
};

export default {
    en: enMessages,
    fr: frMessages
};
